import { useMutation } from '@tanstack/react-query';

import { handleError } from '../../../../../utils/admin';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../../logic/getApiErrorMessage';
import {
  postApplicationTransition,
  TransitionPayload,
} from '../../requests/postApplicationTransition';

export const useApplicationTransition = (
  definitionName: string,
  workflowName: string,
) => {
  const { constructPost } = useRequestConstructor();

  const { mutateAsync: performTransition, ...rest } = useMutation({
    mutationFn: ({ uuid, data }: { uuid: string; data: TransitionPayload }) =>
      postApplicationTransition(
        constructPost,
        uuid,
        definitionName,
        workflowName,
        data,
      ),
    onError: (error) => {
      handleError(getApiErrorMessage(error, 'Transition failed'));
    },
  });

  return { performTransition, ...rest };
};
